import { App } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiPost, errorMessage, qk } from "@/shared/api";

export function useBlockUser(userId: number) {
  const queryClient = useQueryClient();
  const { message } = App.useApp();

  return useMutation({
    mutationFn: (input: { is_blocked: boolean; comment?: string }) =>
      apiPost("/api/v1/admin/users/{user_id}/block", {
        params: { user_id: userId },
        body: input,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qk.user(userId) });
      void queryClient.invalidateQueries({ queryKey: ["users"] });
      void queryClient.invalidateQueries({ queryKey: qk.dashboard() });
      void queryClient.invalidateQueries({ queryKey: ["audit"] });
    },
    onError: (error) => {
      void message.error(errorMessage(error));
    },
  });
}
